import { render, staticRenderFns } from "./Safebox.vue?vue&type=template&id=468889ce&"
import script from "./Safebox.vue?vue&type=script&lang=js&"
export * from "./Safebox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports